import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/recent-market-information/')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
  component: () => null
});
